import { Controller } from "stimulus"

// #1856: de tabbladen bovenaan de pagina (layouts/_tabbladen).
//
// Passen ze niet naast elkaar, dan gaan de laatste tabbladen in een menu
// Meer, met hun volledige naam; het actieve tabblad blijft altijd in de rij.
// Op een smal scherm (telefoon) blijft de rij horizontaal scrollen en staat
// het actieve tabblad in beeld. Zonder JavaScript scrolt de rij ook.
const SMAL = 640

export default class extends Controller {
  static targets = ["rij", "tab", "scheiding", "meer", "meerKnop", "menu"]

  connect() {
    this.verdeel = this.verdeel.bind(this)
    this.buitenKlik = this.buitenKlik.bind(this)
    this.verdeel()
    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(() => this.verdeel())
      this.observer.observe(this.element)
    } else {
      window.addEventListener("resize", this.verdeel)
    }
    document.addEventListener("click", this.buitenKlik)
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    window.removeEventListener("resize", this.verdeel)
    document.removeEventListener("click", this.buitenKlik)
  }

  verdeel() {
    const breedte = this.element.clientWidth
    if (breedte === this.vorigeBreedte) return
    this.vorigeBreedte = breedte

    this.tabTargets.forEach((tab) => { tab.hidden = false })
    this.scheidingTargets.forEach((streep) => { streep.hidden = false })
    this.meerTarget.hidden = true
    this.sluitMeer()

    const rij = this.rijTarget
    if (window.innerWidth < SMAL || rij.scrollWidth <= rij.clientWidth) {
      this.actiefInBeeld()
      return
    }

    this.meerTarget.hidden = false
    const kandidaten = this.tabTargets.filter((tab) => tab.getAttribute("aria-current") !== "page").reverse()
    for (const tab of kandidaten) {
      if (rij.scrollWidth <= rij.clientWidth) break
      tab.hidden = true
    }
    this.verbergLosseStrepen()
    this.vulMenu()
  }

  // Een scheiding tussen twee groepen alleen als er aan beide kanten een tabblad staat
  verbergLosseStrepen() {
    this.scheidingTargets.forEach((streep) => {
      const zichtbaar = (richting) => {
        let buur = streep[richting]
        while (buur) {
          if (buur.matches("[data-hoofdtabbladen-target~='tab']")) return !buur.hidden
          buur = buur[richting]
        }
        return false
      }
      streep.hidden = !(zichtbaar("previousElementSibling") && zichtbaar("nextElementSibling"))
    })
  }

  vulMenu() {
    this.menuTarget.replaceChildren()
    let groep = null
    this.tabTargets.filter((tab) => tab.hidden).forEach((tab) => {
      if (tab.dataset.groepNaam && tab.dataset.groep !== groep) {
        groep = tab.dataset.groep
        const kop = document.createElement("div")
        kop.className = "cc-tabs-menu-kop"
        kop.textContent = tab.dataset.groepNaam
        this.menuTarget.appendChild(kop)
      }
      const link = document.createElement("a")
      link.href = tab.getAttribute("href")
      link.textContent = tab.textContent.trim()
      link.dataset.menuItem = tab.dataset.menuItem
      this.menuTarget.appendChild(link)
    })
    if (this.menuTarget.childElementCount === 0) this.meerTarget.hidden = true
  }

  actiefInBeeld() {
    const actief = this.tabTargets.find((tab) => tab.getAttribute("aria-current") === "page")
    if (!actief) return
    const rij = this.rijTarget
    const links = actief.offsetLeft - rij.offsetLeft
    if (links + actief.offsetWidth > rij.scrollLeft + rij.clientWidth || links < rij.scrollLeft) {
      rij.scrollLeft = Math.max(0, links - 16)
    }
  }

  wisselMeer(event) {
    event.stopPropagation()
    if (this.menuTarget.hidden) {
      this.menuTarget.hidden = false
      this.meerKnopTarget.setAttribute("aria-expanded", "true")
      const eerste = this.menuTarget.querySelector("a")
      if (eerste) eerste.focus()
    } else {
      this.sluitMeer()
    }
  }

  sluitMeer() {
    if (!this.hasMenuTarget || this.menuTarget.hidden) return
    this.menuTarget.hidden = true
    this.meerKnopTarget.setAttribute("aria-expanded", "false")
  }

  buitenKlik(event) {
    if (!this.element.contains(event.target)) this.sluitMeer()
  }
}
